<div class="container"style="display: flex; flex-grow: 1;">
    <div class="viewer-container" style="display: flex; flex-grow: 1;">
        <iframe #pdfIFrame style="display: flex; flex-grow: 1;"></iframe>
    </div>
</div>